<template>
  <div id="app">
    <b-row>
        <lottie
          :options="defaultOptions"
          :height="100"
          :width="100"
          class="lottieDiv"
          v-on:animCreated="handleAnimation"
        />
        <h2>Das Catch Up</h2>
      </b-row>
    <b-container>


      <b-row style="margin-top: 100px;">

        <b-col>
           <router-view />
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>
<script>
import Lottie from "vue-lottie";
import * as animationData from "./assets/record.json";
export default {
  components: {
    Lottie,
  },
  data() {
    return {
      defaultOptions: { animationData: animationData.default },
      animationSpeed: 0.6,
    };
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
      this.anim.play();
    },

    stop: function () {
      this.anim.stop();
    },

    play: function () {
      this.anim.play();
    },

    pause: function () {
      this.anim.pause();
    },

    onSpeedChange: function () {
      this.anim.setSpeed(this.animationSpeed);
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Staatliches&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');

body {
  background-image: url("assets/bg_sun.jpg");
  background-size: cover;
  background-position: fixed;
  background-color: #f0eeeb;
  color: rgb(32, 32, 32);

}

#app {
  font-family: "Staatliches", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* border: 2px solid white; */
}

.lottieDiv {
  margin: 0 0 0 20px !important;
}

h2 {

  color: rgb(51, 51, 51);
  font-size: 2em !important;
  margin: 25px 0 0 0 !important;

}
</style>
